import { createSelector } from '@ngrx/store';
import { memoize } from 'lodash';
import { memoizeByMessageId, selectMessageById } from './message.selectors';
import { ConversationContentAttachment, ConversationMessageContentType, MessageData } from '../models/message-data.model';

export const selectAttachments = memoize((conversationId, messageId) => createSelector(
  selectMessageById(conversationId, messageId),
  message => getAttachments(message)
), memoizeByMessageId);

function getAttachments(message: MessageData): ConversationContentAttachment[] {
  const messageContent = message?.normalizedMessage?.content || [];
  const attachments = messageContent.filter(c => c.contentType === ConversationMessageContentType.Attachment).map(c => c.attachment);
  return attachments;
}
